import React, { useState } from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { getProfileSelector } from '../../../api/module/profile';
import { CustomButton, CustomSelector } from '../../../components';
import INTERNAL_LINKS from '../../../enums/InternalLinks';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function ProfileManagementList({ match, history }) {
  const [selectedProfile, setSelectedProfile] = useState(undefined);

  const breadcrumbItems = [
    {
      text: 'Perfiles',
    },
  ];

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Gestión de proyectos - perfiles
          </Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={6}>
          <Paragraph>Seleccione el perfil de proyectos:</Paragraph>
        </Col>
        <Col span={17} offset={1}>
          <CustomSelector
            selectorProps={{
              style: { width: '100%' },
              placeholder: 'Seleccione el perfil de proyectos... ',
            }}
            endpointFetch={async () => {
              return await getProfileSelector();
            }}
            onChange={(value) => setSelectedProfile(value)}
          />
        </Col>
      </Row>
      <Row justify="space-around" style={{ marginTop: '20px' }}>
        <Col span={8}>
          <CustomButton
            type="default"
            htmlType="button"
            onClick={() => {
              history.push(
                `${INTERNAL_LINKS.PROJECTS_PROFILE}-new/${selectedProfile}`,
              );
            }}
            text="Editar perfil"
            disabled={!selectedProfile}
          />
        </Col>
        <Col span={8}>
          <CustomButton
            type="default"
            htmlType="button"
            onClick={() =>
              history.push(
                `${INTERNAL_LINKS.PROJECTS_PROFILE}-new/${selectedProfile}?isDuplicating=true`,
              )
            }
            text="Duplicar perfil"
            disabled={!selectedProfile}
          />
        </Col>
        <Col span={8}>
          <CustomButton
            type="default"
            htmlType="button"
            onClick={() =>
              history.push(`${INTERNAL_LINKS.PROJECTS_PROFILE}-new`)
            }
            text="Crear nuevo perfil"
          />
        </Col>
      </Row>
    </Content>
  );
}
